import type {RuleResult} from '../types';

export function createResult<Type>(partial: Omit<RuleResult<Type>, 'invalid'>): RuleResult<Type> {
  return {
    ...partial,
    invalid: !partial.valid,
  } as RuleResult<Type>;
}
